var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameControls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751",
    transform: "translate(-435 -3680)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M32,0A32,32,0,1,1,0,32,32,32,0,0,1,32,0Z",
    transform: "translate(435 3680)",
    fill: "#24397a",
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M10.339,26.334l2.83-2.816L16,26.334l2.834-2.816,2.831,2.816L16,32Zm13.183-7.5L26.336,16l-2.814-2.834,2.814-2.828L32,16l-5.666,5.659ZM0,16l5.664-5.663L8.48,13.166,5.664,16,8.48,18.831,5.664,21.659Zm12.569,0A3.428,3.428,0,1,1,16,19.428,3.431,3.431,0,0,1,12.569,16ZM16,5.662,13.169,8.478l-2.83-2.816L16,0l5.666,5.662L18.831,8.478Z",
    transform: "translate(451.002 3696.003)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameControls);
export default __webpack_public_path__ + "static/media/game-controls.752610c52a8c787001afee8fd6d743a0.svg";
export { ForwardRef as ReactComponent };